var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.9226 0.744078L15.2559 4.07741C15.5813 4.40285 15.5813 4.93049 15.2559 5.25592L6.08923 14.4226C5.9729 14.5389 5.82473 14.6182 5.66341 14.6505L1.49674 15.4838C0.913637 15.6004 0.399538 15.0863 0.516158 14.5032L1.34949 10.3366C1.38176 10.1752 1.46105 10.0271 1.57739 9.91074L10.7441 0.744078C11.0695 0.418641 11.5971 0.418641 11.9226 0.744078ZM9.24951 4.595L2.93431 10.9108L2.3956 13.6044L5.08913 13.0657L11.4045 6.75L9.24951 4.595ZM11.3333 2.51184L10.4287 3.41667L12.5828 5.57083L13.4881 4.66667L11.3333 2.51184Z",
  fill: "#767676"
})));
export { SvgEdit as ReactComponent };
export default __webpack_public_path__ + "assets/6ca05fc2.svg";